export default __webpack_public_path__ + "static/media/2SiteCooperando_Desktop_VetorDetratores.1631bdbc.png";